/**
 * @file chart.service.ts
 * @description API сервис для работы с диаграммами и аналитическими данными в Task Manager приложении, который обеспечивает интерфейс для получения данных различных типов диаграмм через REST API. Предоставляет метод get для загрузки конфигурации и данных диаграмм с поддержкой фильтрации и параметризации через POST запросы для построения интерактивных графиков и отчетов.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js']
 * @related-files ['src/features/chart/chart.component.tsx', 'src/api/actions.ts']
 */

import { TApiData } from '@src/types';
import { postRequest } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const ChartService = {
    /**
     * Получает данные диаграммы по имени диаграммы
     * @param {string} name - Имя/тип диаграммы для получения данных
     * @param {TApiData} [body] - Тело запроса с параметрами фильтрации и настройками диаграммы
     * @param {TApiData} [params] - Query параметры для дополнительной конфигурации диаграммы
     * @returns {Promise} Промис с данными диаграммы и дополнительной информацией или ошибкой
     */
    get: async (name: string, body?: TApiData, params?: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postRequest(`chart/${name}`, body, params);
    }
};
